<template>
    <div class="card">
        <div class="card-header">
            <i class="fas fa-code"></i> JollyGo Vue Component
        </div>
        <div class="card-body">
            I am the jollyGo component
        </div>
    </div>
</template>

<script>
    export default {
        name: 'JollyGoComponent',
        mounted() {
            console.log('Component mounted.')
        }
    }
</script>
